import { FIELD_TYPES } from "constants/template-field-type";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    text: {
      type: FIELD_TYPES.TEXT,
      label: "Text"
    },
    author: {
      type: FIELD_TYPES.TEXT,
      label: "Author Name"
    },
    company: {
      type: FIELD_TYPES.TEXT,
      label: "Author Company"
    },
    backgroundColor: {
      type: FIELD_TYPES.COLOR_PICKER,
      label: "Background Color"
    }
  }
};
